export default __webpack_public_path__ + "static/media/fassaden5.617c5a86.jpg";